import React from 'react';
import { useNavigate } from 'react-router-dom';
const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

const ConfirmPayment = ({ paymentMethod, onClose, total }) => {
  const navigate = useNavigate();

  const handleProceed = async () => {
    if (paymentMethod === 'Cash' || paymentMethod === 'UPI') {
      // Retrieve necessary values from localStorage
      const billingId = localStorage.getItem('billingId');
      const reservationId = localStorage.getItem('reservationId');
      const finalAmount = localStorage.getItem('finalAmount');

      if (!billingId || !reservationId || !finalAmount) {
        alert('Missing required information in local storage.');
        return;
      }

      // Prepare the payload for the POST request
      const payload = {
        booking_id: reservationId, // reservationId is used as booking_id in the API
        billing_id: billingId,
        amount: finalAmount,
        receipt_number: `RECEIPT-${new Date().toISOString()}`, // Example receipt number, format it as needed
      };

      try {
        // Make the POST request to the payment API
        const response = await fetch(`${BQ_BASE_URL}/bq/api/payments/cash`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (response.ok) {
          console.log('Payment successful', data);
          // Navigate to the successful payment screen
          navigate('/payment-succesful'); // Adjust if needed
        } else {
          alert('Payment failed: ' + data.message || 'Unknown error');
        }
      } catch (error) {
        console.error('Error during payment:', error);
        alert('An error occurred while processing the payment.');
      }
    } else {
      // For other payment methods, navigate to OTP screen
      navigate('/otp');
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-white w-[500px] p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-semibold text-center mb-2">Confirm Your Transaction</h2>
        <p className="text-sm text-gray-600 text-center mb-6">
          Please review your payment details before proceeding.
        </p>

        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="font-medium text-gray-700">Total amount:</span>
            <input
              type="text"
              value={`Rs. ${total}`} // Display the total amount dynamically
              readOnly
              className="border border-gray-300 px-4 py-2 rounded-md w-[200px] bg-gray-100 text-gray-800"
            />
          </div>

          <div className="flex justify-between items-center">
            <span className="font-medium text-gray-700">Payment Method:</span>
            <input
              type="text"
              value={paymentMethod} // Display the correct payment method (e.g., "Cash", "UPI")
              readOnly
              className="border border-gray-300 px-4 py-2 rounded-md w-[200px] bg-gray-100 text-gray-800"
            />
          </div>
        </div>

        <div className="flex justify-center gap-6 mt-6">
          <button
            onClick={onClose} // Add onClose functionality to cancel
            className="bg-red-600 text-white px-6 py-2 rounded hover:text-black"
          >
            Cancel
          </button>
          <button
            onClick={handleProceed} // Trigger navigation to the appropriate page
            className="bg-[#1d42b0] text-white px-6 py-2 rounded hover:text-black"
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPayment;
